<script lang="ts">
    export let fill:string = "none";
    export let height:string = "22";
    export let width:string = "22";
    export let x: string = "0";
    export let y: string = "0";
</script>

<svg {x} {y} {width} {height} viewBox="0 0 22 22" {fill} xmlns="http://www.w3.org/2000/svg">
<path d="M18.6208 4.78607L8.60559 14.8012L4.79837 10.994L3.54431 12.2481L8.60559 17.3094L19.8748 6.04013L18.6208 4.78607Z"/>
</svg>
